import React from "react";
import ProductForm from "./ProductFrom";

// Replaces the old AdminAddProduct.jsx (which had the unbalanced </div> at line 665).
const AdminAddProduct = () => <ProductForm mode="add" />;

export default AdminAddProduct;